import { render, staticRenderFns } from "./PropriedadeManage.vue?vue&type=template&id=780230a2&scoped=true"
import script from "./PropriedadeManage.vue?vue&type=script&lang=js"
export * from "./PropriedadeManage.vue?vue&type=script&lang=js"
import style0 from "./PropriedadeManage.vue?vue&type=style&index=0&id=780230a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780230a2",
  null
  
)

export default component.exports